import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator, storeImageViewer } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { AddVehicleTypeResponse } from "../../../models/response/vehicleType/AddVehicleTypeResponse";
import { GetVehicleTypeByIdResponse } from "../../../models/response/vehicleType/GetVehicleTypeByIdResponse";
import CustomTextInput from "../../../components/CustomTextInput";
import { CommonService } from "../../../services/CommonService";
import { UploadFileResponse } from "../../../models/response/common/UploadFileResponse";
import { AddConstantResponse } from "../../../models/response/constant/AddConstantResponse";
import { GetConstantByIdResponse } from "../../../models/response/constant/GetConstantByIdResponse";

const VehicleTypeAdd = () => {
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Araç Cinsi Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [vehicleTypeId, setVehicleTypeId] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const fileRef: any = useRef();
    const [file, setFile] = useState<File | undefined>(undefined);
    const [b64, setB64] = useState(Helpers.getPlaceholder());
    const [additionalValue1, setAdditionalValue1] = useState<string | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetConstantByIdResponse = await ConstantService.getConstantById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setVehicleTypeId(response.data.constantId);
                setName(response.data.value);
                setAdditionalValue1(response.data.additionalValue1);
                setB64(response.data.additionalValue2);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveVehicleType = async () => {
        try {
            if (!name || Helpers.isEmpty(name)) {
                toast.error('Araç Cinsi Adı alanını doldurunuz!');
                return;
            }

            dispatch(storeActivityIndicator(true));

            var fileUri = undefined;

            if (file) {
                var response: UploadFileResponse = await CommonService.uploadFile(file);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                fileUri = response.data;
            }

            var response2: AddConstantResponse = await ConstantService.addConstant(vehicleTypeId, 'VEHICLE_TYPE', name, undefined, additionalValue1, fileUri ?? b64);

            if (!response2.isSuccess) {
                toast.error(response2.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response2.message)

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const handleFileRead = async (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => {
        try {
            const file = event.target.files[0]
            const base64: any = await convertBase64(file)
            setFunction(base64);
        } catch (error) {
            setFunction(Helpers.getPlaceholder())
        }
    }

    const convertBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Araç Cinsi Adı</label>
                                        <CustomTextInput value={name} setValue={setName} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Araç Cinsi Resimi</label>
                                        <input accept="image/*" ref={fileRef} onChange={(e) => { setFile(e && e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined); handleFileRead(e, setB64); }} type="file" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Resim</label>

                                        <Box>
                                            <img onClick={() => dispatch(storeImageViewer([b64 ? b64 : Helpers.getPlaceholder()]))} style={{ maxWidth: 100 }} className="actionIcon img img-thumbnail" src={b64 ? b64 : Helpers.getPlaceholder()} />
                                        </Box>
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveVehicleType}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment >
    )
}

export default VehicleTypeAdd;